// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SortArrows_wrapper__2tmud","showing":"SortArrows_showing__3yFcA"};